import { AssetItem, AssetJson } from '@/type/assetListItem';
import { request } from '@easytwin/runtime';
import apis from '@/constants/apis';

export const getUserAssets = async (options?: {
  pageSize?: number;
  pageNumber?: number;
  id?: string;
  name?: string;
}) => {
  const res = await request(apis.resourceGet, { query: options });

  const assets: AssetItem[] = [];
  res.data.forEach((j) => {
    const json = j as AssetJson;

    const asset: AssetItem = {
      type: json.type,
      name: json.name,
      url: json.content.url,
      id: json.id,
      thumb: json.thumb ?? '',
      parentId: json.parentId,
      content: json.content,
      createdAt: json.createdAt ?? '',
      children: [],
    };
    assets.push(asset);
  });

  return assets;
};

export const updateAsset = async (query: { assetId: string; name?: string; parentId?: string }) => {
  const { assetId, name, parentId } = query;
  const res = await request(apis.resourcePatch, {
    params: {
      id: assetId,
    },
    body: {
      name,
      parentId,
    },
  });

  return res;
};

export const UserAssetListApi = {
  getUserAssets,
  updateAsset,
};
